import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import '../../styles/carrosselConvenios.css';

import convenioUnimed from '../../img/conveniosimg/Unimed.png';

const CarrosselConvenios: React.FC = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <>
      <div className="white_background">
        <div ref={ref} className="carousel_container_convenios">
          <h2 className="clinica_convenios">Convênios</h2>
          <h3 className="clinica_convenios"> Particular e Social</h3>

          {inView && (
            <div className="convenio_bloco_wrapper">
              <div className="convenio_linha">
                <motion.div
                  initial={{ x: -150, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1 }}
                  className="convenio_bloco"
                >
                  <a href="https://www.unimed.coop.br/site/web/portoalegre/" target="_blank" rel="noopener noreferrer">
                  <img src={convenioUnimed} alt="Unimed" className="convenio_imagem" /></a>
                  <div className="convenio_texto">
                    <h3><b>Unimed</b></h3>
                    <p className="text_convenio_unimed">
                      A Unimed é referência em saúde no Brasil, oferecendo ampla cobertura em planos médicos e hospitalares por meio de cooperativas médicas.
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CarrosselConvenios;
